import { useCallback, useState } from 'react';

export default function useSignal() {
   const [signal, triggerSignal] = useState({});
   const staticTriggerFn = useCallback(() => triggerSignal({}), [triggerSignal]);
   return [signal, staticTriggerFn];
}
